module.exports = __webpack_public_path__ + "img/Womens-Month-01.1672e772.jpg";